export default __webpack_public_path__ + "static/media/stuttgart-card.1e702074.png";